<template>
  <div>
    <div class="relative flex flex-col min-w-0 break-words w-full mb-6 p-4 shadow-lg rounded-lg bg-white">
      <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div class="flex flex-wrap items-center">
          <div class="relative w-full max-w-full flex-grow flex-1">
            <h6 class="uppercase text-blueGray mb-1 text-xs font-semibold">
              Overview of Current Teaching And Learning Management
            </h6>
            <h2 class="text-blueGray text-xl font-semibold">
              Subjects Present in Doctor of Medicine Program
            </h2>
          </div>
        </div>
      </div>

      <div class="flex-auto">
        <div class="w-full">
          <div class="relative flex flex-col min-w-1  break-words bg-white w-full">
            <div class="px-4 py-5 flex-auto ">
              <div class="tab-content tab-space ">
                <div class="relative">
                  <canvas ref="chartCanvas" v-on:click="toggleModal()"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal_subject_open ref="modal_sub" />
  </div>
</template>

<script>
import { Bar } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import api from './../../services/student_services';
import Modal_subject_open from "@/components/Cards/Modal_subject_open.vue";

export default {
  name: "large-modal",
  data() {
    return {
      // no_data,
      showModal: false,
      subject_med_arr: [],
    }
  },
  mounted() {
  },
  components: {
    Modal_subject_open
  },
  methods: {
    async subject_med() {
      api.subject_med().then(async (result) => {
        this.subject_med_arr = result.data;

        this.$nextTick(function () {

          const ctx = this.$refs.chartCanvas.getContext('2d');
          const data_year = [];
          const data_sum = [];

          this.subject_med_arr.forEach((subject_list) => {
            data_year.push("Year " + subject_list.class_year);
            data_sum.push(subject_list.sum_sub);
          });

          new Bar(ctx, {
            data: {
              labels: data_year,
              datasets: [
                {
                  label: 'Number of Subjects/Subject Group',
                  data: data_sum,
                  backgroundColor: "#00A65A",
                },
              ],
            },
            options: {
              responsive: true,
              interaction: {
                intersect: false,
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero:true
                  }
                }]
              },
              plugins: {
                datalabels: {
                  // align: 'end',
                  // anchor: 'end',
                  // color: function (context) {
                  //   return context.dataset.backgroundColor;
                  // },
                  color: '#FFFFFF',
                  formatter: (data) => {
                    return data != 0 ? data : '';
                  },
                  font: function (context) {
                    var w = context.chart.width;
                    return {
                      size: w < 512 ? 12 : 14,
                      weight: 'bold',
                    };
                  },
                  // formatter: function (value, context) {
                  //   return context.chart.data[context.dataIndex];
                  // }
                }
              }
            },
            plugins: [ChartDataLabels],
          });
        });

      });
    },
    
    toggleModal: function () {
      this.$refs.modal_sub.showAlert({
        message: "med"
      });
    },
    getSlowValue(index) {
      return this.data.datasets[0].data[index].slowValue;
    },

  }, created: async function () {
    await this.subject_med()
  },
};
</script>
